module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-4.a1d8283f.jpg";